import { Image } from "antd";
import type { FC } from "react";

import { PageLayout } from "../../../components/AppLayout/components/Content/components";
import type { NoneOwnProps } from "../../../core/types";
import background from "./assets/eft_paymnet_lightgreen.png";

/**
 * Landing Page container
 * */
export const LandingPage: FC<NoneOwnProps> = () => {
    return (
        <PageLayout name="landing-page">
            <Image preview={false} src={String(background)} />
        </PageLayout>
    );
};
